// TBD: come up better name. What is the braintree card? Is it provider or another super service?
var StripeCard = (function (PaymentProviderBase, CheckoutSettings, StripeHelper) {

    var StripeCard = PaymentProviderBase.extend({
        type: 'card',
        paymentOption: CheckoutSettings.PaymentOption.Stripe,
        _supportedTypes: stripeSupportedTypes.card,
        _supportedOrderTypes: stripeSupportedOrderTypes.card,
        _supportedProviderType: CheckoutSettings.PaymentOption.Stripe,

        initialize: function (attrs, opts) {

            this.hideErrors = !!opts.hideErrors;
            this._logger = opts.logger;

            attrs._getStripe().done(_.bind(function(stripe) {
                this.stripe = stripe;
            }, this));

        },

        prepayment: function () {
            return this.stripe.getPayload()
                .fail(function(result) {
                    if (result.error && result.error.message) {
                        alert(result.error.message);
                    }
                });
        },

        complete: function (paymentMethodId) {

            var transactionData = {
                paymentType: 'stripe',
                paymentMethodId: paymentMethodId
            };

            if (typeof (paymentMethodId) === 'object') {
                transactionData.paymentMethodId = paymentMethodId.Token || paymentMethodId.id;
                transactionData.paymentType = paymentMethodId.paymentType || transactionData.paymentType;
            }

            this._logger && this._logger('Stripe');

            var _method = _.bind(this._createPaymentTransaction, this);
            var $result = new $.Deferred();

            _method(transactionData, { wait: true, preventDoubleRequests: true, hideErrors: false })
                .then(this.stripe.handleServerResponce)
                .then(function(result) {
                    if (typeof (result) === "string") {
                        var transactionData = {
                            paymentType: 'stripe',
                            paymentIntentId: result
                        };
                        return _method(transactionData,
                            { wait: true, preventDoubleRequests: true, hideErrors: this.hideErrors });
                    }
                    return result;
                })
                .then(function(result) {
                    if (!result.Result || !result.Value.isPaid || result.Value.response === 'basket_changed') {
                        $result.reject(result);
                    } else {
                        $result.resolve(result);
                    }
                })
                .fail($result.reject);
            return $result.promise();
		}
	});

	return StripeCard;
})(PaymentProviderBase, CheckoutSettings, StripeHelper);
